/**
 * @fileoverview Present the locally generated signature and explicit clipboard controls. `kc-internal-frontend/src/lib/signature-utils.js` owns output construction/copy boundaries; the parent owns source fields. Sanitized preview is presentation, while installing the signature in an email provider remains outside this workspace.
 */

import React, { useState, useContext } from 'react';
import Button from "../../shared/AppButton";
import DOMPurify from 'dompurify';
import { generateSignatureHtml, copyToClipboard, copyTextToClipboard } from '../../../lib/signature-utils';
import ToastContext from '../../../ToastContext';



export default function SignaturePreview({ data }) {
  const [previewMode, setPreviewMode] = useState('email');
  const showToast = useContext(ToastContext);

  const signatureHtml = generateSignatureHtml(data);

  const handleCopyHtml =

  async () => {
    const success = await copyTextToClipboard(signatureHtml);
    if (success) {
      showToast({
        severity: "success",
        summary: "Success!",
        detail: "HTML code copied to clipboard successfully!"
      });
    } else {
      showToast({
        severity: "error",
        summary: "Error",
        detail: "Failed to copy HTML code. Please try again."
      });
    }
  };

  const renderEmailPreview =

  () => {
    return (
      <div className="signature-generator__preview border-1 surface-border border-round p-4 bg-white" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(signatureHtml) }}>
      </div>);

  };

  const renderHtmlCodeView =

  () =>
  <div className="border-1 surface-border border-round p-3 bg-gray-50" style={{ minHeight: '300px' }}>
      <div className="flex justify-content-between align-items-center mb-3">
        <h3 className="text-sm font-medium text-gray-700 m-0">
          HTML Code for Email Signature
        </h3>
        <Button
        label="Copy Code"
        icon="pi pi-copy"
        onClick={handleCopyHtml}
        className="p-button-sm" />

      </div>
      <div style={{
      maxHeight: '250px',
      overflowY: 'auto',
      overflowX: 'auto',
      width: '1px',
      minWidth: '100%',
      maxWidth: '100%'
    }}>
        <pre className="text-xs text-gray-600 app-data-block" style={{ whiteSpace: 'pre', margin: 0, padding: 0 }}>
          {signatureHtml}
        </pre>
      </div>
    </div>;


  return (
    <div style={{ minWidth: 0 }}>
        <div className="flex justify-content-between align-items-center mb-4">
            <h2 className="text-xl font-semibold text-900 m-0">Signature Preview</h2>
            <div className="flex gap-2">
                <Button
            label="Email View"
            onClick={() => setPreviewMode("email")}
            className={`p-button-sm ${previewMode === 'email' ? '' : 'p-button-outlined'}`} />

                <Button
            label="HTML Code"
            onClick={() => setPreviewMode("html")}
            className={`p-button-sm ${previewMode === 'html' ? '' : 'p-button-outlined'}`} />

            </div>
        </div>
        {previewMode === "email" ? renderEmailPreview() : renderHtmlCodeView()}
    </div>);

}
